import { useCallback } from 'react';
import { useLoginUserWithGoogleMutation } from 'shared/hooks/queries/use-login-user-with-google-mutation';

export const useLoginWithGoogle = () => {
  const { mutateAsync, error, reset, isPending } =
    useLoginUserWithGoogleMutation();

  const login = useCallback(async () => {
    await mutateAsync();
  }, [mutateAsync]);

  return { login, error, reset, isLoading: isPending };
};
